@if (article) {
	<div class="grid items-center grid-cols-1 gap-6 md:grid-cols-2">
		<a
			[routerLink]="urlParts"
			class="block h-56 p-4 bg-center bg-cover rounded-md"
			[ngStyle]="{ 'background-image': 'url(' + (article?.img_name | cdn) + ')' }"
			><span class="sr-only">View article: {{ article?.title | ucEntities }}</span>
		</a>
		<div class="space-y-2 md:py-4">
			<a
				class="block font-medium text-uc-blue-600"
				[routerLink]="['/advice/', article?.cat_name | categoryLink: 'advice']"
				>{{ article?.cat_name }}</a
			>
			<a [routerLink]="urlParts" class="block text-xl font-bold">{{
				article?.title | ucEntities
			}}</a>
			<p class="text-gray-500">
				{{ article?.date_posted | ucdate }}
				@if (article?.reading_time > 0) {
					&middot; {{ article?.reading_time }} min read
				}
			</p>
			<p class="text-base text-gray-500">
				{{ article?.quote | ucEntities }}
			</p>
		</div>
	</div>
}
